import { h, Component } from 'preact';
import styles from './styles.scss';
import { SearchIconNew } from '../../shared/svg/icons/search';
import { I18n } from '../../shared/context';
import { Link } from '../../shared/link';
import { Button } from '../../shared/button';
import { withTheme } from '../../shared/withTheme';
import { trackNavAction } from '../tracking/clientEventTracking';

const searchInputId = 'js-header-search';
const searchIconId = 'js-search-button';

const quizRegex = /\/(?<page>quizzes)(\/?)/g;

const SearchIcon = withTheme(({ theme, id }) => {
  return (
    <SearchIconNew className={`${styles.searchIcon} ${theme.searchIcon}`} role="img" aria-labelledby={id}>
      <I18n.Consumer>
        {i18n => <title id={id}>{i18n.search}</title>}
      </I18n.Consumer>
    </SearchIconNew>
  );
});

class SearchInput extends Component {
  componentDidMount() {
    this.input.focus();
  }

  render({ id }) {
    return (
      <I18n.Consumer>{i18n => (
        <form onSubmit={() => trackNavAction({ location: 'search', action_value: this.input.value })} className={styles.searchInputContainer} role="search" action="/search">
          <label htmlFor={id} className={styles.searchLabel}>{i18n.search}</label>
          <input id={id} className={styles.searchInput} type="search" name="q" placeholder={i18n.search} autocomplete="off" ref={input => this.input = input} data-bfa="@a:search;@d:input;" />
          {this.props.isQuizFeed ? <input type="hidden" name="type" value="quiz" /> : null}
        </form>
      )}</I18n.Consumer>
    );
  }
}

export class Search extends Component {
  constructor() {
    super();
    this.state = {
      inputVisible: false,
      isQuizFeed: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.setState({
        ...this.state,
        isQuizFeed: quizRegex.test(window.location.pathname),
      });
    }
  }

  onClick(clickEvent) {
    clickEvent.preventDefault();
    this.setState({
      ...this.state,
      inputVisible: !this.state.inputVisible
    });
  }

  render() {
    return (
      <div className={this.state.inputVisible ? `${styles.search} ${styles.active}` : styles.search}>
        <div>
          {/* Link on small screens, button on large screens   */}
          <Link className={`${styles.searchLink}`} href={this.state.isQuizFeed ? '/search?type=quiz' : '/search'} location={'search'}>
            <SearchIcon id={`${searchIconId}-mobile`}/>
          </Link>
          <I18n.Consumer>
            { i18n =>
              <Button className={`${styles.searchButton}`} aria-label={i18n.a11y_search} onClick={this.onClick} location={'search'} aria-controls={searchInputId} aria-expanded={String(this.state.inputVisible)}>
                <SearchIcon id={`${searchIconId}-desktop`}/>
              </Button>
            }
          </I18n.Consumer>
        </div>
        {this.state.inputVisible && <SearchInput id={searchInputId} isQuizFeed={this.state.isQuizFeed} />}
      </div>
    );
  }
}
